<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [title]="'Activity'"
    [canGoBack]="true"
    [customBack]="backPath" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<tidy-unified-agent
  [mobileView]="'activity'"
  [triggerKey]="triggerKey" />
